<template>    
    <div class="lavelTabContentWrap">   
        <LoadingOverlay :loading="loading" />     
        <div class="lavelTab-topBox">
            <CharmLevelUserInfoComponent />
        </div>
        <div class="lavelRule-infoBox">
            <h3 class="subHd">Level Rule</h3>
            <div class="title">The level is counted by the Beans you had earned</div>
            <div class="lavelRule-tableWrap">
                <table>
                    <thead>
                        <tr>
                            <th>Charm Level</th>
                            <th>Beans Earned</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="levelData in UserCharmLevelData " :key="levelData.id">
                            <td>
                                <div class="userLabelBox">
                                    <img :src="getLevelImage(levelData.level)" class="lavelImage" alt="level icon" />
                                    <span class="uaserLabelVal">{{ levelData.level }}</span>
                                </div>
                            </td>
                            <td>{{ levelData.amount }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import CharmLevelUserInfoComponent from './CharmLevelUserInfoComponent.vue'
import LoadingOverlay from '../LoadingOverlay.vue'
import beansIcon from '../../assets/images/beansIcon.png'
export default {
    name: 'CharmLevel',
    components: {
        CharmLevelUserInfoComponent, 
        LoadingOverlay       
    },
    data() {
        return {
            UserCharmLevelData: [],
            beansIcon: beansIcon,  
            loading: false,          
        }
    },
    watch: {
        '$route.params.profile_id': 'fetchUserCharmLevelData'
    },
    mounted() {
        this.fetchUserCharmLevelData();
    },
    methods: {
        fetchUserCharmLevelData() {     
            this.loading = true;       
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            // const apiUrl = `https://ringlive.in/api/user-rich-charm-level-details?type=charm_level`;
            const apiUrl = `api/user-rich-charm-level-details?type=charm_level`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.UserCharmLevelData = response.data.result.levellist;
                })

                .catch(error => {
                    console.error("Error Featching Charm Level Data", error)
                })  
                .finally(() => {
                    this.loading = false;
                })              
        },
        getLevelImage(charm_level) {
            switch (true) {
                case charm_level === 0:
                    return require('@/assets/images/charm-lavel-0.png');
                case charm_level === 1:
                    return require('@/assets/images/charm-lavel-1.png');
                case charm_level >= 2 && charm_level <= 5:
                    return require('@/assets/images/charm-lavel-2.png');
                case charm_level >= 6 && charm_level <= 10:
                    return require('@/assets/images/charm-lavel-4.png');
                case charm_level >= 11 && charm_level <= 15:
                    return require('@/assets/images/charm-lavel-5.png');
                case charm_level >= 16 && charm_level <= 20:
                    return require('@/assets/images/charm-lavel-6-10.png');
                case charm_level >= 21 && charm_level <= 25:
                    return require('@/assets/images/charm-lavel-11-15.png');
                case charm_level >= 26 && charm_level <= 30:
                    return require('@/assets/images/charm-lavel-16-20.png');
                    
                // case charm_level === 0:
                //     return require('@/assets/images/charm-lavel-0.png');
                // case charm_level === 1:
                //     return require('@/assets/images/charm-lavel-1.png');
                // case charm_level === 2:
                //     return require('@/assets/images/charm-lavel-2.png');
                // case charm_level === 3:
                //     return require('@/assets/images/charm-lavel-3.png');
                // case charm_level === 4:
                //     return require('@/assets/images/charm-lavel-4.png');
                // case charm_level === 5:
                //     return require('@/assets/images/charm-lavel-5.png');
                // case charm_level >= 6 && charm_level <= 10:
                //     return require('@/assets/images/charm-lavel-6-10.png');
                // case charm_level >= 11 && charm_level <= 15:
                //     return require('@/assets/images/charm-lavel-11-15.png');
                // case charm_level >= 16 && charm_level <= 20:
                //     return require('@/assets/images/charm-lavel-16-20.png');
                default:
                    return require('@/assets/images/charm-lavel-0.png');
            }
        },
    },
}
</script>